<ion-card class="kv-kartya">
  <ion-card-header>
    <ion-card-title>Késve rögzített mulasztások</ion-card-title>
    <ion-card-subtitle>
      {{ jogalap }}: „A tanuló mulasztással összefüggő adatait a mulasztás napján, haladéktalanul rögzíteni kell a
      tanulmányi rendszerben.” Azok az órák, amelyeken van hiányzó, és amelyeket az óra napjánál később könyveltek.
      A késés naptári napban értendő, és a könyvelés idejéhez mér: ha a hiányzót aznap beírták, de az órát csak később
      könyvelték, az is itt látszik; a könyveletlen óra nincs a listában. Az átvételből (gépi vagy tömeges
      könyvelés, a napló használatba vétele előtti napok) származó késés alapból nem számít.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="kv-eszkozok">
      <ion-segment *ngIf="admin" class="kv-hatokor" [value]="hatokor" (ionChange)="hatokorValt($event.detail.value)">
        <ion-segment-button value="osztaly"><ion-label>Ez az osztály</ion-label></ion-segment-button>
        <ion-segment-button value="intezmeny"><ion-label>Egész intézmény</ion-label></ion-segment-button>
      </ion-segment>
      <ion-input class="kv-datum" type="date" label="Ettől" labelPlacement="stacked" [(ngModel)]="tol"></ion-input>
      <ion-input class="kv-datum" type="date" label="Eddig" labelPlacement="stacked" [(ngModel)]="ig"></ion-input>
      <ion-button size="small" (click)="betoltes()" [disabled]="betolt">
        <ion-icon slot="start" name="search-outline"></ion-icon>Lekérdezés
      </ion-button>
      <ion-button size="small" fill="clear" (click)="csv()" [disabled]="!sorok.length">
        <ion-icon slot="start" name="download-outline"></ion-icon>CSV
      </ion-button>
      <ion-toggle class="kv-atvetel-kapcsolo" [checked]="atvetellel" [disabled]="betolt" justify="start" labelPlacement="end"
                  (ionChange)="atvetelValt($event.detail.checked)">Átvételből származók is</ion-toggle>
    </div>

    <div *ngIf="betolt" class="kv-ures"><ion-spinner name="crescent"></ion-spinner> Lekérdezés…</div>
    <div *ngIf="!betolt && hiba" class="kv-hiba">{{ hiba }}</div>

    <ng-container *ngIf="!betolt && !hiba">
      <div *ngIf="kihagyva.okok.length" class="kv-atvetel-info">
        <ng-container *ngIf="!atvetellel">
          <b>{{ kihagyva.ora_db }}</b> átvételből származó késve könyvelt óra (<b>{{ kihagyva.hianyzo_db }}</b> hiányzó-bejegyzés)
          <b>nincs benne</b> a kimutatásban – nem a tanár késett. Az „Átvételből származók is” kapcsolóval jelölve megjeleníthetők.
        </ng-container>
        <ng-container *ngIf="atvetellel">Az átvételből származó órák is benne vannak, „átvétel” címkével jelölve:</ng-container>
        <ul>
          <li *ngFor="let o of kihagyva.okok">
            <b>{{ o.nev }}</b> – {{ o.ora_db }} óra, {{ o.hianyzo_db }} hiányzó. {{ o.magyarazat }}
            <span *ngIf="o.kod === 'bevezetes_elott' && naploKezdeteSzoveg">Az első könyvelés: {{ naploKezdeteSzoveg }}.</span>
          </li>
        </ul>
      </div>

      <div *ngIf="!osszesen.ora_db" class="kv-ures">A választott időszakban nincs késve könyvelt, hiányzós óra.</div>

      <ng-container *ngIf="osszesen.ora_db">
        <p class="kv-osszeg">
          <b>{{ osszesen.ora_db }}</b> késve könyvelt óra, <b>{{ osszesen.hianyzo_db }}</b> hiányzó-bejegyzés,
          <b>{{ osszesen.tanar_db }}</b> tanár ({{ pontos(tol) }} – {{ pontos(ig) }}).
        </p>

        <h4 class="kv-alcim">Tanáronként <span class="kv-halvany">– kattints egy tanárra a soraihoz</span></h4>
        <table class="kv-tabla">
          <thead>
            <tr><th>Tanár</th><th>Késve könyvelt óra</th><th>Hiányzók</th><th>Átlagos késés (nap)</th><th>Legnagyobb késés</th><th>Utolsó</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of tanarok" class="kv-kattinthato" [class.kv-kivalasztott]="tanar === t.tanar" (click)="tanarValaszt(t)">
              <td>{{ t.tanar_nev || t.tanar }}</td>
              <td>{{ t.ora_db }}<span class="kv-halvany" *ngIf="atvetellel && t.atvetel_db"> (ebből átvétel: {{ t.atvetel_db }})</span></td>
              <td>{{ t.hianyzo_db }}</td>
              <td>{{ t.atlag_keses }}</td>
              <td><span class="kv-cimke" [ngClass]="kesesSzint(t.max_keses)">{{ t.max_keses }} nap</span></td>
              <td>{{ pontos(t.utolso) }}</td>
            </tr>
          </tbody>
        </table>

        <h4 class="kv-alcim">
          Órák<ng-container *ngIf="tanar"> – {{ tanarNev }}
            <ion-button size="small" fill="clear" (click)="tanarValaszt(null)">
              <ion-icon slot="start" name="close-outline"></ion-icon>minden tanár
            </ion-button>
          </ng-container>
          <span class="kv-halvany" *ngIf="csonkitva"> – az első 5000 sor látszik, szűkítsd az időszakot</span>
        </h4>
        <div class="kv-gorgeto">
          <table class="kv-tabla">
            <thead>
              <tr><th>Dátum</th><th>Óra</th><th>Osztály / csoport</th><th>Tantárgy</th><th>Tanár</th><th>Könyvelve</th><th>Késés</th><th>Hiányzó</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let s of sorok">
                <td>{{ pontos(s.datum) }}</td>
                <td>{{ sav(s) }}</td>
                <td>{{ s.osztaly || '' }}<span class="kv-halvany" *ngIf="s.csoport"> {{ s.osztaly ? '· ' : '' }}{{ s.csoport }}</span></td>
                <td>{{ s.tantargy || '–' }}</td>
                <td>
                  {{ s.tanar_nev || s.tanar }}<span class="kv-halvany" *ngIf="s.helyettesites"> (helyettesítés)</span>
                  <div class="kv-halvany" *ngIf="s.konyvelte && s.konyvelte.toLowerCase() !== s.tanar.toLowerCase()">könyvelte: {{ s.konyvelte_nev || s.konyvelte }}</div>
                </td>
                <td>
                  {{ pontos(s.konyvelve) }}
                  <div class="kv-halvany" *ngIf="s.egy_menetben > 1"
                       title="Ugyanez a könyvelő ugyanebben a percben ennyi késve könyvelt, hiányzós órát rögzített – utólagos tömeges pótlás (vagy átvétel) jele.">
                    egy menetben: {{ s.egy_menetben }} óra
                  </div>
                </td>
                <td>
                  <span class="kv-cimke" [ngClass]="kesesSzint(s.keses_nap)">{{ s.keses_nap }} nap</span>
                  <div *ngIf="s.atvetel"><span class="kv-cimke kv-atvetel" [title]="atvetelMagyarazat(s.atvetel)">átvétel: {{ atvetelNev(s.atvetel) }}</span></div>
                </td>
                <td>{{ s.hianyzo_db }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </ng-container>
  </ion-card-content>
</ion-card>
